export const buildSpecsFromHeaters = (heaters, elementsOptions) =>
  (Array.isArray(heaters) ? heaters : [])
    .filter((partNumber) => partNumber)
    .map(
      (partNumber) =>
        (Array.isArray(elementsOptions) ? elementsOptions : []).find(
          (element) => element?.partNumber === partNumber,
        ) ??
        { partNumber },
    );
